import React from 'react';

function Footer() {
  return (
    <footer className="mdc-footer">
      <div className="footer-content">
        {/* Copyright Section */}
        <section className="mdc-footer__section copyright">
          <p className="copyright-text">© 2026 MailVotes. All Rights Reserved.</p>
        </section>
        
        {/* Social Media Section */}
        <section className="mdc-footer__section social-media">
          <nav className="footer-social-links">
            <a href="https://twitter.com" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="https://facebook.com" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="https://linkedin.com" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://instagram.com" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
          </nav>
        </section>
        
        {/* Privacy and Disclaimer Section */}
        <section className="mdc-footer__section policies">
          <p><a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
